<app-loader [hideSpinner]="isDataLoaded"></app-loader>
<nav [ngClass]="{ 'hidden': !isDataLoaded }" class="list-header navbar navbar-light bg-light">
  <span class="navbar-brand">Product List</span>
  <div class="navbar-nav mr-auto"></div>
  <button mat-stroked-button (click)="addProduct()">
    <mat-icon>add</mat-icon>
    <span>Add Product</span>
  </button>
</nav>
<div [ngClass]="{ 'hidden': !isDataLoaded }" class="list-container">
  <div class="filter-container">
    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
    </mat-form-field>
  </div>
  <mat-table [dataSource]="dataSource" matSort matSortActive="Id" matSortDirection="asc">
    <ng-container matColumnDef="Id">
      <mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.Id}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Name">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
      <mat-cell *matCellDef="let row"> 
        <span>{{row.Name}}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="ImageUrl">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Image </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.ImageUrl}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Active">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.Active ? 'Active' : 'Inactive'}} </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="viewProduct(row.Id)"></mat-row>
  </mat-table>

  <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
</div>